'use client';

import { useEffect } from 'react';

import { useConsent } from 'utils/consent/ConsentProvider';

interface ConsentScriptProps {
  category: 'C0001' | 'C0002' | 'C0003' | 'C0004';
  src: string;
  id: string;
  attrs?: Record<string, string>;
  async?: boolean;
  defer?: boolean;
}

declare global {
  interface Window {
    __CSP_NONCE__?: string;
  }
}

export const ConsentScript = ({ category, src, id, attrs, async = true, defer = true }: ConsentScriptProps) => {
  const { consentGroups, isLoaded } = useConsent();
  const hasConsent = consentGroups.includes(category);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    if (!hasConsent) {
      return;
    }
    if (document.getElementById(id)) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = id;
    script.async = async;
    script.defer = defer;
    script.src = src;
    if (window.__CSP_NONCE__) {
      script.nonce = window.__CSP_NONCE__;
    }

    if (attrs) {
      Object.entries(attrs).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });
    }

    document.head.appendChild(script);
  }, [hasConsent, isLoaded, src, id, category]);

  return null;
};
